import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-component-couple-users-multiselect',
    templateUrl: './couple-users-multiselect.component.html',
    styleUrls: ['./couple-users-multiselect.component.scss']
})
export class CoupleUsersMultiselectComponent implements OnInit {

    @Input('formData') public formData;
    private invites = [];

    constructor() {
    }

    ngOnInit(): void {
    }

    userList(e): void {
        const list = [];
        for (const item of e.invites) {
            const data = {email: item.email, ...item.formGroup.value};
            list.push(data);
        }
        this.invites = Array.from(new Set([...this.invites, ...list]));
    }
}
